import { useMutation, MutationHookOptions } from '@apollo/client';

import { ACCEPT_REJECT_CONVERSION } from '../queries/acceptAndRejectConversionMutation';
import { AcceptAndRejectAffiliateConversion, AcceptAndRejectAffiliateConversionVariables } from '../queries/types/AcceptAndRejectAffiliateConversion';

type TOptions = MutationHookOptions<AcceptAndRejectAffiliateConversion, AcceptAndRejectAffiliateConversionVariables>;

export const useAcceptRejectConversion = (options: TOptions = {}) => useMutation<AcceptAndRejectAffiliateConversion, AcceptAndRejectAffiliateConversionVariables>(ACCEPT_REJECT_CONVERSION, options);
